import type { ReactElement } from 'react';
import {
  Business as CompanyIcon,
  Factory as UnitIcon,
  Domain as DepartmentIcon,
  Work as OccupationIcon,
  Person as EmployeeIcon,
} from '@mui/icons-material';

import type { NivelDeAplicacao } from '../../types/nivelDeAplicacao';

/**
 * O ícone de cada nível de aplicação, num mapa só (#541). É `Record` completo de propósito: um
 * nível novo na lista única deixa de compilar aqui, em vez de aparecer sem ícone no seletor.
 */
export const ICONE_DO_NIVEL: Record<NivelDeAplicacao, ReactElement> = {
  company: <CompanyIcon />,
  unit: <UnitIcon />,
  department: <DepartmentIcon />,
  occupation: <OccupationIcon />,
  employee: <EmployeeIcon />,
};
